import React from 'react';
import firebase from 'firebase';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import Moment from 'moment';

class Users extends React.Component {

  state = {
    user: localStorage.currentUser,
    currentUserInfo: {
      vipUsers: []
    },
    type:localStorage.type,
    users: [],
    payoutMultiplier: 0
  };

  componentDidMount() {
    this.getCurrentUserInfo();
  }

  getCurrentUserInfo() {
    firebase.database().ref('user').orderByChild('uid').equalTo(localStorage.currentUser).once('value', (data) => {
      const object = data.val();
      
      const user = object[Object.keys(object)[0]];
      user.userKey = Object.keys(object)[0];
      this.setState({currentUserInfo: user, payoutMultiplier: user.payoutMultiplier});
      this.getItems();
    });
  }

  getItems () {
    var items = firebase.database().ref('user');
    var itemArray = [];

    if(this.state.type === 'business') {
      // Find all coupons related to the business
      firebase.database().ref('coupons').orderByChild('promotion/userUid').equalTo(this.state.user).once('value', (data) => {
        var object = data.val();
        for (var key in object) {
          if (object.hasOwnProperty(key)) {
            itemArray.push(object[key]);
          }
        }
        this.collateUsers(itemArray);
      });
    } else if(this.state.type === 'admin') {
      items.once('value', (data) => {
        var object = data.val();
        for (var key in object) {
          if (object.hasOwnProperty(key) && object[key].type === 'user') {
            itemArray.push(object[key]);
          }
        }
        this.setState({items:itemArray})
      });
    }
  }

  collateUsers(coupons) {
    let usersObject = {};
    let users = [];
    coupons.forEach((coupon) => {
      if(coupon.createdByUser) {
        let user = coupon.createdByUser;
        user.vip = this.state.currentUserInfo.vipUsers ? this.state.currentUserInfo.vipUsers.includes(user.uid) : false;
        usersObject[coupon.createdBy] = coupon.createdByUser;
      }
    });
    Object.keys(usersObject).map(function(key){
      users.push(usersObject[key]);
    });
    this.setState({items: users});
  }

  doSomething(id, action) {
    let {currentUserInfo} = this.state;
    if(action === 'add') {
      if(!currentUserInfo.vipUsers) {
        currentUserInfo.vipUsers = [];
      }
      currentUserInfo.vipUsers.push(id);
    } else {
      currentUserInfo.vipUsers = currentUserInfo.vipUsers.filter(e => e !== id);
    }

    this.setState({currentUserInfo: currentUserInfo});
    this.updateUser();
  }

  updateUser(type) {
    let refUser = firebase.database().ref('user').child(this.state.currentUserInfo.userKey).update(this.state.currentUserInfo);
    if(refUser && type) {
      alert("Payout Multiplier Updated")
    }
  }

  createdAt(cell, row) { return cell ? Moment(cell).format('Do MMM YY HH:mm') : 'N/A' }
  vipUser(cell, row) { 
    if(this.state.currentUserInfo.vipUsers && this.state.currentUserInfo.vipUsers.includes(row.uid)) {
      return <button className="btn btn-sm btn-danger" onClick={this.doSomething.bind(this, row.uid, 'remove')}>Unset as VIP</button>
    } else {
      return <button className="btn btn-sm btn-success" onClick={this.doSomething.bind(this, row.uid, 'add')}>Set as VIP</button>
    }
  }

  handleChange(e) {
    this.setState({payoutMultiplier: e.target.value});
  }

  updatePayout() {
    let {currentUserInfo} = this.state;
    currentUserInfo.payoutMultiplier = this.state.payoutMultiplier;

    if (this.state.payoutMultiplier > 2) {
      alert('The payout multiplier cannot be above 2');
      return;
    }

    this.setState({currentUserInfo: currentUserInfo});
    this.updateUser('payout');
  }

  render()  {

    if(!this.state.users) {
      return;
    }

    return (
      <div>

       <BootstrapTable data={this.state.items}   exportCSV={ true } pagination striped hover>
          <TableHeaderColumn isKey dataField='firstName' dataSort>First Name</TableHeaderColumn>
          <TableHeaderColumn dataField='lastName' dataSort>Last Name</TableHeaderColumn>
          <TableHeaderColumn dataField='email'>Email</TableHeaderColumn>
          { localStorage.type === 'admin' && <TableHeaderColumn dataField='telephone'>Telephone</TableHeaderColumn> }
          { localStorage.type === 'business' && <TableHeaderColumn dataField='userUid' dataFormat={this.vipUser.bind(this)} dataSort>VIP</TableHeaderColumn> }
        </BootstrapTable>

        <br/><br/>
        { this.state.type === 'business' &&
          <div>
            <h4>VIP Payout Multipier</h4>
            <input value={this.state.payoutMultiplier} style={{'width': '75px'}} type="number" max="2" onChange={(e) => {this.handleChange(e)}}></input>
            &nbsp;
            <button onClick={this.updatePayout.bind(this)} className="button btn btn-sm btn-success">Update</button>
          </div>
        }

      </div>
    );
  }
}

export default Users;


// WEBPACK FOOTER //
// ./src/containers/Users.js